import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { isNullOrUndefinedOrEmpty } from '../../../../helpers/common';
import { propBool, propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
const ConsultantSearchInput = (props) => {
    const { defaultKeyword, inputRef, isEnableBlur, isReverse, onChange, onClear, onSubmit, placeholder, showNewIcon, showSearchIcon, value, } = props;
    const showClearIcon = !isNullOrUndefinedOrEmpty(value);
    return (_jsxs("form", Object.assign({ className: `search_input_block ${showSearchIcon ? 'is-show-searchIcon' : ''} ${showClearIcon ? 'is-show-clearIcon' : ''} ${isReverse ? 'is-reverse' : ''}`, onSubmit: onSubmit }, { children: [!isReverse && showSearchIcon && (_jsx("i", Object.assign({ className: 'search_input_block_searchIcon material-icons' }, { children: "search" }))), isReverse && showSearchIcon && (_jsx("button", Object.assign({ className: 'search_input_block_searchIcon', type: 'submit' }, { children: _jsx("i", Object.assign({ className: 'material-icons' }, { children: "search" })) }))), _jsx("input", { className: 'search_input_block_input appearance-none', defaultValue: value === undefined ? defaultKeyword : undefined, name: 'keyword', onBlur: isEnableBlur ? onSubmit : undefined, onChange: onChange, placeholder: placeholder, ref: inputRef, type: 'search', value: value }), showClearIcon && (_jsx("button", Object.assign({ className: 'search_input_block_clearIcon', onClick: onClear, type: 'button' }, { children: _jsx("i", Object.assign({ className: 'material-icons' }, { children: "clear" })) }))), showNewIcon && (_jsx("span", Object.assign({ className: 'search_input_block_newText' }, { children: "New!" })))] })));
};
ConsultantSearchInput.propTypes = {
    defaultKeyword: propStr(),
    inputRef: propShape(),
    isEnableBlur: propBool(),
    isReverse: propBool(),
    onChange: propFunc(),
    onClear: propFunc().isRequired,
    onSubmit: propFunc().isRequired,
    placeholder: propStr(),
    showNewIcon: propBool(),
    showSearchIcon: propBool(),
    value: propStr(),
};
ConsultantSearchInput.defaultProps = {
    defaultKeyword: '',
    inputRef: undefined,
    isEnableBlur: false,
    isReverse: false,
    onChange: undefined,
    placeholder: '市場調査、KPI策定、新事業検討、など',
    showNewIcon: false,
    showSearchIcon: true,
    value: undefined,
};
export default ConsultantSearchInput;
